import { useCallback, useContext } from 'react';
import { RiImageEditFill } from 'react-icons/ri';
import { useHistory } from 'react-router';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../actions/auth-context';
import { getOrderToEdit } from '../../../../actions/order.service';

const EditOrderButton = ({ order }) => {
  const { hasPermissions } = useContext(AuthContext);

  const history = useHistory();

  const getEditOrder = useCallback(async (data) => {
    const response = await getOrderToEdit(data.id, {
      action_note: null,
    });

    if (!response.error) history.push(`/orders/${data.id}`);
  }, []);

  return (
    <>
      {order.order_status === 'Financeiro aprovado' &&
        hasPermissions(['edit_photos']) && (
          <RiImageEditFill
            size={25}
            className="mb-1 action"
            data-tip="Editar Pedido"
            onClick={() => getEditOrder(order)}
          />
        )}
    </>
  );
};

EditOrderButton.propTypes = {
  order: PropTypes.shape({
    order_status: PropTypes.string,
  }).isRequired,
};

export default EditOrderButton;
